module.exports = __webpack_public_path__ + "static/media/29BDOS23.074d68be.jpg";